import ProfileAlertsListService from "@services/profile-alerts-list-service";
import { getSingleInstanceByElement, getSingleInstanceByName, initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { notifyFromAlert } from "../helpers/notifs";
import TabLayoutParent from "../tablayout/tablayout-parent";
import ProfileAlert from "./profile-alert";

const alertLevel: AlertLevel = {
  Info: 1,
  Error: 2,
  Warning: 3,
};

interface AlertLevel {
  [index: string]: any;
}

interface ProfileAlertsListProps {
  url: string;
}

export default class ProfileAlertsList extends Component {
  private hash: string;
  private functionsOptions: any;
  private contractsOptions: any;
  private creationButton: HTMLElement;
  private layoutParent: TabLayoutParent;
  private data: any;

  constructor(private props: ProfileAlertsListProps, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.layoutParent = getSingleInstanceByName("TabLayoutParent");
    this.togglelazyLoading(true);
    document.querySelector<HTMLInputElement>(
      "input[data-notification]"
    ).checked = false;
    this.initAddButton();
    // Used to know if there is an alert to open
    this.hash = this.element.getAttribute("data-profile-alerts-hash");

    if (this.props.url) {
      this.call(this.props.url);
    }
  }
  initAddButton(): void {
    this.creationButton = this.element.querySelector(".alert-creation-button");
    this.creationButton.addEventListener("click", () => {
      this.appendAlert(
        {
          functionsOptions: this.functionsOptions,
          contractsOptions: this.contractsOptions,
          name: "",
          locality: "",
          contracts: [],
          functions: [],
          frequency: "",
        },
        true
      );

      //Add tracking on click to add an alert
      window.dataLayer.push(this.data.trackingsClick[0]);
    });
  }
  call(url: string): void {
    const service = new ProfileAlertsListService(url);
    service.get((response: any) => {
      this.data = response;
      if (!this.data.contractOptions || !this.data.functionOptions) {
        this.displayError();
        this.togglelazyLoading(false);
        return;
      }
      this.functionsOptions = this.data.functionOptions;
      this.contractsOptions = this.data.contractOptions;

      if (!this.data.alertes || !this.data.alertes.length) {
        this.addNewAlert();
      } else {
        let open,
          needScroll = false;

        for (let i = 0; i < this.data.alertes.length; i++) {
          const alert = this.data.alertes[i];
          open = this.hash === alert.hash;
          if (open) {
            needScroll = true;
          }
          alert.open = open;
          alert.contractsOptions = this.contractsOptions;
          alert.functionsOptions = this.functionsOptions;

          this.appendAlert(alert);
        }

        if (this.hash === "new") {
          this.creationButton.dispatchEvent(new Event("click"));
        }
      }

      // Add tracking on page load
      if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
        const tracking = this.data.trackingsLoad[0];
        tracking.event = "VirtualPageview";
        if (
          !("IntersectionObserver" in window) ||
          !("IntersectionObserverEntry" in window) ||
          !("intersectionRatio" in window.IntersectionObserverEntry.prototype)
        ) {
          // If IntersectionObserver is not available, just send the load event
          window.dataLayer.push(tracking);
        } else {
          const observer = new IntersectionObserver(function (entries) {
            // When visibility state change, check if the current element is visible
            if (entries[0].intersectionRatio > 0) {
              // If it's visible, send the load event
              window.dataLayer.push(tracking);
            }
          });

          // Start observing the current element
          observer.observe(this.element);
        }
      }

      // Look for a message to display
      if (this.data.messages && this.data.messages.length) {
        this.displayNotification({
          Icon: alertLevel[this.data.messages[0].level],
          Message: this.data.messages[0].content,
          AnalyticsTrackings: "",
          sticky: true,
        });
      }

      initialiseComponents();
      this.togglelazyLoading(false);
    });
    service.setErrorHandler(() => {
      this.displayError();
      this.togglelazyLoading(false);
    });
  }
  togglelazyLoading(lazy: boolean): void {
    if (this.layoutParent) {
      this.layoutParent.toggleLazyTabs(lazy);
    }
    if (lazy) {
      this.element.classList.add("lazy");
    } else {
      this.element.classList.remove("lazy");
    }
  }
  addNewAlert(): void {
    this.element.classList.add("no-alerts");

    this.appendAlert(
      {
        functionsOptions: this.functionsOptions,
        contractsOptions: this.contractsOptions,
      },true, true
    );
  }
  appendAlert(alert: any, isNew?: boolean, noAlerts?: boolean): void {
     const data = {
       alert: alert,
       noAlerts: !!noAlerts,
       url: this.props.url,
     };

     const alertsList = this.element.querySelector("div.alert-list");
     const alertEL = document.createElement("div");
     alertEL.setAttribute("data-profile-alert", JSON.stringify(data));
     alertsList.insertBefore(alertEL, alertsList.firstChild);

     initialiseComponents();

    const profileALertInstance:ProfileAlert = getSingleInstanceByElement("ProfileAlert", alertEL);
     if (isNew) {
       // If it's a new alert, disable the creation button until it's saved
       this.creationButton.classList.add("disabled");
     }

     PubSub.subscribe("profile-alert.created", () => {
        this.creationButton.classList.remove("disabled");
        this.element.classList.remove("no-alerts");
     });

  }
  displayNotification(notification: any) {
    notifyFromAlert(notification, true);
  }
  displayError(): void {
    notifyFromAlert(
      {
        Icon: 2,
        Message:
          "Aïe, une erreur est survenue, rechargez la page et réessayez.",
        AnalyticsTrackings: "",
        sticky: true,
      },
      true
    );
  }
}
